import { useLoginStore } from '../../../store/useLogin';
import sessionExpiredImage from '../../../assets/img/session_expired.png';
import BigButton from '../../button/BigButton';
import { useCallback } from 'react';

/**
 * @author taulmax
 * @date 2024.10.21
 * @description 로그인 세션 만료 시 보여주는 모달 컴포넌트
 */
const SessionExpiredModal = () => {
  const { isTokenExpired, isAuthenticated } = useLoginStore();

  const goLogin = useCallback(() => {
    window.location.href = '/login';
  }, []);

  if (!isAuthenticated) {
    goLogin();
    return null;
  }

  if (!isTokenExpired) return null;

  return (
    <div className="session_expired_modal_bg">
      <div className="session_expired_modal">
        <img src={sessionExpiredImage} alt="expired_img" />
        <div className="session_expired_info">
          <h1>로그인 세션이 만료되었습니다.</h1>
          <span>
            <b>개인정보보호</b>를 위하여 다시 <b>로그인</b> 해 주세요.
          </span>
          <BigButton type="submit" text="로그인하러 가기" onClick={goLogin} />
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
